/**
 * Aurum & Ash — Product Page JS
 * Handles: variant selection, image gallery, quantity, add to cart
 */
(function () {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const form = section.querySelector('[data-product-form]');
  const variantSelect = section.querySelector('[data-variant-select]');
  const optionButtons = section.querySelectorAll('[data-option-value]');
  const mainImage = section.querySelector('[data-product-featured-image]');
  const thumbnails = section.querySelectorAll('[data-thumbnail]');
  const addToCartBtn = section.querySelector('[data-add-to-cart]');
  const priceWrapper = section.querySelector('[data-price-wrapper]');

  // Quantity controls
  const quantityMinus = section.querySelector('[data-quantity-minus]');
  const quantityPlus = section.querySelector('[data-quantity-plus]');
  const quantityInput = section.querySelector('[data-quantity-input]');

  if (quantityMinus && quantityPlus && quantityInput) {
    quantityMinus.addEventListener('click', function () {
      const val = parseInt(quantityInput.value) || 1;
      if (val > 1) quantityInput.value = val - 1;
    });
    quantityPlus.addEventListener('click', function () {
      const val = parseInt(quantityInput.value) || 1;
      quantityInput.value = val + 1;
    });
  }

  // Thumbnail gallery
  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(function (t) { t.classList.remove('aa-product__thumbnail--active'); });
      thumb.classList.add('aa-product__thumbnail--active');
      if (mainImage) {
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.alt = thumb.dataset.imageAlt || '';
      }
    });
  });

  // Variant picker
  if (variantSelect && optionButtons.length > 0) {
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const index = parseInt(btn.dataset.optionIndex);
        // Deselect siblings
        const siblings = section.querySelectorAll('[data-option-index="' + index + '"]');
        siblings.forEach(function (s) {
          s.classList.remove('aa-product__variant-option--selected');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('aa-product__variant-option--selected');
        btn.setAttribute('aria-pressed', 'true');

        // Build selected options
        var selectedOptions = [];
        var optionGroups = section.querySelectorAll('.aa-product__variant-options');
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.aa-product__variant-option--selected');
          if (active) selectedOptions.push(active.dataset.optionValue);
        });

        // Find matching variant
        var options = variantSelect.options;
        for (var i = 0; i < options.length; i++) {
          var optionData = JSON.parse(options[i].dataset.variantOptions);
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (optionData[j] !== selectedOptions[j]) { match = false; break; }
          }
          if (match) {
            variantSelect.value = options[i].value;
            updateVariant(options[i]);
            break;
          }
        }
      });
    });
  }

  function updateVariant(option) {
    var isAvailable = !option.disabled;

    // Update button
    if (addToCartBtn) {
      addToCartBtn.disabled = !isAvailable;
      addToCartBtn.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    }

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  }

  // Add to cart via fetch (for cart drawer)
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Added!';
          setTimeout(function () { addToCartBtn.textContent = 'Add to Cart'; }, 1500);

          // Update cart count and open drawer
          if (window.AurumAsh && window.AurumAsh.cart) {
            window.AurumAsh.cart.refresh();
            window.AurumAsh.cart.open();
          }
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        });
    });
  }
})();
